/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAppSessionsStats, getStatisticsSuccess } from "../../../actions";
import Popup from "reactjs-popup";
import PeriodSelector from "../../PeriodSelector";
import Statistics from "..";
import moment from "moment";
import "./styles.scss";

const AppSessions = ({ getAppSessionsStats, appSessions }) => {
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    getStatisticsSuccess({ type: "appSessions", loading: true });
    getAppSessionsStats({
      startDate: "",
      endDate: ""
    });
  }, []);

  const handlePeriodApply = (periodData) => {
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    
    // Handle API call logic - pass dates directly without formatting
    if (periodData.type === "all") {
      getStatisticsSuccess({ type: "appSessions", loading: true });
      getAppSessionsStats({
        startDate: "",
        endDate: "",
      });
    } else if (periodData.startDate) {
      getStatisticsSuccess({ type: "appSessions", loading: true });
      getAppSessionsStats({
        startDate: periodData.startDate,
        endDate: periodData.endDate,
      });
    }
  };

  return (
    <div className="statistics-sessions-container col">
      <div className="app-sessions-content">
        {/* Element 1: Total Sessions */}
        <div className="app-sessions-row">
          <div className="indicator blue" />
          <div className="app-sessions-text-container">
            <div className="app-sessions-header">
              <h3 className="app-sessions-main-text">
                {appSessions?.totalSessions || "0"} TOTAL IN APP SESSIONS
              </h3>
              <div className="app-sessions-period-selector">
                <p className="period-label">{selectedPeriodLabel}</p>
                <Popup
                  className="popup-header-options-container"
                  trigger={<div className="settings-icon" />}
                  position="bottom right"
                  closeOnDocumentClick
                >
                  {(close) => (
                    <PeriodSelector
                      selectedPeriod={selectedPeriodType}
                      onApply={(periodData) => {
                        handlePeriodApply(periodData);
                        close();
                      }}
                    />
                  )}
                </Popup>
              </div>
            </div>
            <p className="app-sessions-sub-text">
              1 session = staying in for min 5 sec
            </p>
          </div>
        </div>

        {/* Element 2: Unique Active Users */}
        <div className="app-sessions-row secondary">
          <div className="indicator blue lighter" />
          <div className="app-sessions-text-container">
            <h3 className="app-sessions-secondary-text">
              {appSessions?.uniqueUsers || "0"} UNIQUE ACTIVE USERS
            </h3>
          </div>
        </div>

        {/* Element 3: Average User Sessions */}
        <div className="app-sessions-row secondary">
          <div className="indicator blue lighter" />
          <div className="app-sessions-text-container">
            <h3 className="app-sessions-secondary-text">
              {appSessions?.totalSessions && appSessions?.uniqueUsers 
                ? Math.round(appSessions.totalSessions / appSessions.uniqueUsers)
                : "0"} AVERAGE USER SESSIONS
            </h3>
          </div>
        </div>

        {/* Panel 1: Session Length */}
        <div className="app-sessions-panel">
          <div className="app-sessions-panel-title">
            <h3>SESSION LENGTH</h3>
          </div>
          <div className="app-sessions-panel-content">
            {appSessions?.loading ? (
              <Statistics.LoaderInline />
            ) : (
              <Statistics.Horizontal
                data={[
                  {
                    value: "Under a minute",
                    label: appSessions?.sessions?.underMinute || 0,
                  },
                  {
                    value: "1-5 minutes",
                    label: appSessions?.sessions?.["1-5"] || 0,
                  },
                  {
                    value: "5-30 minutes",
                    label: appSessions?.sessions?.["5-30"] || 0,
                  },
                  {
                    value: "30-60 minutes",
                    label: appSessions?.sessions?.["30-60"] || 0,
                  },
                  {
                    value: "Over an hour",
                    label: appSessions?.sessions?.overHour || 0,
                  },
                ]}
              />
            )}
          </div>
        </div>

        {/* Panel 2: By Users */}
        <div className="app-sessions-panel">
          <div className="app-sessions-panel-title">
            <h3>BY USERS</h3>
          </div>
          <div className="app-sessions-panel-content">
            {appSessions?.loading ? (
              <Statistics.LoaderInline />
            ) : (
              <Statistics.Horizontal
                data={[
                  {
                    value: "Owner",
                    label: appSessions?.countByRole?.owner || 0,
                  },
                  {
                    value: "Landlord with Tenant",
                    label: appSessions?.countByRole?.landlordWithTenant || 0,
                  },
                  {
                    value: "Landlord without Tenant",
                    label: appSessions?.countByRole?.landlordWithoutTenant || 0,
                  },
                  {
                    value: "Tenant",
                    label: appSessions?.countByRole?.tenant || 0,
                  },
                  {
                    value: "Tenant with Landlord",
                    label: appSessions?.countByRole?.tenantWithLandlord || 0,
                  },
                  {
                    value: "Tenant without Landlord",
                    label: appSessions?.countByRole?.tenantWithoutLandlord || 0,
                  },
                  {
                    value: "User without Property",
                    label: appSessions?.countByRole?.userWithoutProperty || 0,
                  },
                ]}
              />
            )}
          </div>
        </div>

        {/* Panel 3: Times Opened */}
        <div className="app-sessions-panel">
          <div className="app-sessions-panel-title">
            <h3>TIMES OPENED</h3>
          </div>
          <div className="app-sessions-panel-content">
            {appSessions?.loading ? (
              <Statistics.LoaderInline />
            ) : (
              <Statistics.Horizontal
                data={[
                  {
                    value: "1-5 times",
                    label: appSessions?.timesOpened?.["1-5"] || 0,
                  },
                  {
                    value: "6-10 times",
                    label: appSessions?.timesOpened?.["6-10"] || 0,
                  },
                  {
                    value: "11-15 times",
                    label: appSessions?.timesOpened?.["11-15"] || 0,
                  },
                  {
                    value: "16-20 times",
                    label: appSessions?.timesOpened?.["16-20"] || 0,
                  },
                  {
                    value: "Over 20 times",
                    label: appSessions?.timesOpened?.over20 || 0,
                  },
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  appSessions: state.dashboard.appSessions,
});

const mapDispatchToProps = (dispatch) => ({
  getAppSessionsStats: (payload) => dispatch(getAppSessionsStats(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSessions);
